import React, { useState } from 'react';
import TopNavigation from './TopNavigation';
import SideNavigation from './SideNavigation';
import ErrorModal from '../ui/ErrorModal';
import GlobalLoader from '../ui/GlobalLoader';

const Layout = ({ children }) => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <TopNavigation onHamburgerClick={() => setMobileSidebarOpen(true)} />
      {/* Mobile sidebar drawer */}
      <div className={`fixed inset-0 z-40 md:hidden ${mobileSidebarOpen ? '' : 'pointer-events-none'}`}> 
        {/* Overlay */}
        <div
          className={`fixed left-0 right-0 top-16 bottom-0 bg-black/40 transition-opacity duration-200 ${mobileSidebarOpen ? 'opacity-100' : 'opacity-0'}`}
          aria-hidden="true"
          onClick={() => setMobileSidebarOpen(false)}
        />
        {/* Drawer */}
        <div className={`fixed left-0 top-16 bottom-0 w-64 bg-muted shadow-lg transform transition-transform duration-200 ${mobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
          <button
            className="absolute top-4 right-4 text-muted-foreground hover:text-foreground focus:outline-none"
            onClick={() => setMobileSidebarOpen(false)}
            aria-label="Close sidebar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <SideNavigation mobile={true} />
        </div>
      </div>
      <div className="flex flex-col md:flex-row h-auto md:h-[calc(100vh-4rem)]">
        <SideNavigation />
        <main className="flex-1 overflow-y-auto">
          <div className="p-2 sm:p-4 md:p-6">
            {children}
          </div>
        </main>
      </div>
      {/* Global Error Modal for 500 errors */}
      <ErrorModal />
      {/* Global Loading Spinner */}
      <GlobalLoader />
    </div>
  );
};

export default Layout; 